export class PetTagModel {
    pet_no: number
    profile_sequence: number
    chip_no: string
    rabie_tag_no: string
    rabie_vacc_date: string
    license_no: string

    constructor(
        pet_no: number,
        profile_sequence: number,
        chip_no: string,
        rabie_tag_no: string,
        rabie_vacc_date: string,
        license_no: string
    ) {
        this.pet_no = pet_no
        this.profile_sequence = profile_sequence
        this.chip_no = chip_no
        this.rabie_tag_no = rabie_tag_no
        this.rabie_vacc_date = rabie_vacc_date
        this.license_no = license_no
    }
}